import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReportRunnerComponent } from '../../components/report-runner/report-runner.component';

@Component({
  selector: 'app-services-provided-report',
  imports: [ReportRunnerComponent],
  templateUrl: './services-provided-report.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServicesProvidedReportComponent {}
